import React from "react";
import {Helmet} from "react-helmet";
import Banksy from "../../assets/images/Banksy.jpg";
import Andy from "../../assets/images/Andy.jpg";

export default function FifteenMinutes() {
    return (
        <div>
            <Helmet>
                <title>十五分钟 Fifteen Minutes</title>
            </Helmet>
            <h6 className="App-essay-title">十五分钟</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二五 十二月</b>
                <br/><br/>
                <img src={Andy} alt="Andy Warhol" className={"App-home-image"}/>
                <br/><br/>
                <i style={{ color: 'grey' }}>In the future, everyone will be world-famous for 15 minutes. ——Andy Warhol</i><br/>
                <i style={{ color: 'grey' }}>在未来，每个人都能成名15分钟。——安迪·沃霍尔</i>
                <br/><br/>
                每天接触很多信息，书籍，图像，代码，公众号，视频号，youtube…我不用抖音，但好朋友发来的抖音可以在3秒内用“钩子”，把我带到一个压根没准备好要去的地方。此外，如果天性思维活跃，那么想在这个世界上保持专注和内心安定，比长生不老还难。
                <br/><br/>
                把情绪和专注交给不断成为焦点的各种主角和事件，它们能随时吞噬情绪和注意力，而我毫无还手之力。
                <br/><br/>
                热闹见识过了，正面交锋我输得很彻底。
                <br/><br/>
                但物极必反，我猜反面也很精彩，也果真如此。
                <br/><br/>
                <img src={Banksy} alt="Banksy" className={"App-home-image"}/>
                <br/><br/>
                <i style={{ color: 'grey' }}>In the future, everyone will be anonymous for 15 minutes. ——Banksy</i><br/>
                <i style={{ color: 'grey' }}>在未来，每个人都只有15分钟的机会做个无名氏。——班克西</i>
                <br/><br/>
                出名十五分钟和匿名十五分钟，都只有十五分钟。我看明白了，这一切与出名和匿名无关，它的毛病出在十五分钟。
                <br/><br/>
                无论背景多嘈杂，如果真正关心一件事超过十五分钟，那解药就找到了。无论这件事有无任何价值。
                <br/><br/>
                <i style={{ color: 'grey' }}>Images: Nano Banana.🍌</i><br/>


            </p>

            <br/>

            <h6 className="App-essay-title">Fifteen Minutes</h6>
            <p className="App-essay-article">
                <br/>
                <b>Dec 2025</b>
                <br/><br/>


            </p>
        </div>)
}
